import type { Card } from '../../types';

export const ENFEEBLE: Card = {
  id: 'enfeeble',
  name: 'Enfeeble',
  type: 'support',
  rarity: 'rare',
  size: { w: 1, h: 2 },
  cost: [{ kind: 'min', value: 4 }],
  effects: [
    {
      kind: 'applyStatus',
      application: { status: 'weaken', magnitude: 3, duration: 3, target: 'opponent' },
    },
  ],
};
